class Embed {
  constructor(el) {
    this.el = el;
    if (!this.el) return;

    if ("url" in this.el.dataset) {
      const contentURL = this.el.dataset.url;

      if (contentURL) {
        this.render();
        this.load(contentURL, "body > *");
      }
    }
  }

  render(content, completed = false) {
    if (!completed) {
      this.el.classList.add("loading");
    } else {
      this.el.classList.remove("loading");

      if (content) {
        // 内容を空にする
        while (this.el.firstChild) {
          this.el.removeChild(this.el.firstChild);
        }
        this.el.appendChild(content);
      }
    }
  }

  async load(contentURL, selector) {
    const res = await fetch(contentURL);

    if (res.ok) {
      if (res.headers.get("x-data-found") === "false") {
        // Workersで該当データなし
        this.render(null, true);
      } else {
        const text = await res.text();
        const parser = new DOMParser();
        const dom = parser.parseFromString(text, "text/html");
        const content = dom.querySelector(selector);

        this.manipulate(content, contentURL);
        this.render(content, true);
      }
    } else {
      this.render(null, true);
    }
  }

  manipulate(content, contentURL) {
    if (content) {
      content.querySelectorAll("a").forEach((el) => {
        if (el.hasAttribute("href")) {
          el.setAttribute("target", "_blank");
        }
      });
    }
  }
}


document.querySelectorAll(".embed").forEach((el) => {
  new Embed(el);
});
